import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { useAuth } from './hooks/useAuth.jsx'
import Layout from './components/Layout/Layout'
import ProtectedRoute from './components/Auth/ProtectedRoute'
import LandingPage from './pages/Landing/LandingPage'
import Login from './pages/Auth/Login'
import Dashboard from './pages/Dashboard/Dashboard'
import QuizList from './pages/Quiz/QuizList'
import QuizForm from './pages/Quiz/QuizForm'
import QuizPreview from './pages/Quiz/QuizPreview'
import QuizTaking from './pages/Quiz/QuizTaking'
import QuizResults from './pages/Quiz/QuizResults'
import StudentsList from './pages/Students/StudentsList'
import StudentDetail from './pages/Students/StudentDetail'
import MyQuizzes from './pages/Students/MyQuizzes'
import MyResults from './pages/Students/MyResults'
import Profile from './pages/Profile/Profile'
import CategoryList from './pages/Category/CategoryList'
import EventQuizList from './pages/EventQuiz/EventQuizList'
import EventQuizForm from './pages/EventQuiz/EventQuizForm'
import EventQuizHost from './pages/EventQuiz/EventQuizHost'
import EventQuizJoin from './pages/EventQuiz/EventQuizJoin'
import EventQuizPlay from './pages/EventQuiz/EventQuizPlay'
import EventQuizDisplay from './pages/EventQuiz/EventQuizDisplay'
import LoadingSpinner from './components/UI/LoadingSpinner'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner />
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Routes>
        {/* Page d'accueil publique */}
        <Route 
          path="/" 
          element={user ? <Navigate to="/dashboard" replace /> : <LandingPage />} 
        />
        
        {/* Preview publique de quiz */}
        <Route
          path="/quiz/:id/preview"
          element={<QuizPreview />}
        />

        {/* Routes publiques Event Quiz (pas besoin d'auth) */}
        <Route path="/event-quiz/join" element={<EventQuizJoin />} />
        <Route path="/event-quiz/join/:code" element={<EventQuizJoin />} />
        <Route path="/event-quiz/play/:sessionId" element={<EventQuizPlay />} />
        <Route path="/event-quiz/display/:code" element={<EventQuizDisplay />} />
        
        {/* Routes publiques */}
        <Route 
          path="/login" 
          element={user ? <Navigate to="/dashboard" replace /> : <Login />} 
        />
        
        {/* Routes protégées */}
        <Route 
          path="/*" 
          element={
            user ? (
              <Layout>
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  
                  {/* Routes accessibles à tous */}
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/profile" element={<Profile />} />
                  
                  {/* Routes ÉTUDIANT uniquement */}
                  <Route path="/my-quizzes" element={<MyQuizzes />} />
                  <Route path="/my-results" element={<MyResults />} />
                  
                  {/* Routes ADMIN uniquement - DOIVENT ÊTRE AVANT les routes avec paramètres */}
                  <Route 
                    path="/quiz" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <QuizList />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/quiz/create" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <QuizForm mode="create" />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/quiz/:id/edit" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <QuizForm mode="edit" />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/students" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <StudentsList />
                      </ProtectedRoute>
                    } 
                  />
                  <Route 
                    path="/students/:id" 
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <StudentDetail />
                      </ProtectedRoute>
                    } 
                  />
                  <Route
                    path="/categories"
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <CategoryList />
                      </ProtectedRoute>
                    }
                  />

                  {/* Routes admin Event Quiz */}
                  <Route
                    path="/event-quiz"
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <EventQuizList />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/event-quiz/create"
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <EventQuizForm mode="create" />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/event-quiz/:id/edit"
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <EventQuizForm mode="edit" />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/event-quiz/host/:sessionId"
                    element={
                      <ProtectedRoute requiredRole="admin">
                        <EventQuizHost />
                      </ProtectedRoute>
                    }
                  />
                  
                  {/* Routes de quiz avec paramètres - APRÈS les routes exactes */}
                  <Route path="/quiz/:id" element={<QuizTaking />} />
                  <Route path="/quiz/:quizId/results/:attemptId" element={<QuizResults />} />
                  <Route path="/results/:attemptId" element={<QuizResults />} />
                  
                  <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
              </Layout>
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />
      </Routes>
    </Box>
  )
}

export default App
